import numeral from 'numeral'

export const seismicSValueFormatter = (sValue: number) => {
  return numeral(sValue).format('0.[00]')
}

const twoDecimalsFormatter = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** Whether the value prints as "0,00" with two decimals (incl. -0 and e.g. -0.004). */
export const roundsToZeroInTwoDecimals = (value: number): boolean => Number(value.toFixed(2)) === 0

/** German two-decimal format (`1.234,57`); values that round to zero print as "0,00", not "-0,00". */
export const formatTwoDecimals = (value: number): string =>
  twoDecimalsFormatter.format(roundsToZeroInTwoDecimals(value) ? 0 : value)

const compactAbbreviations = ['', 'k', 'm', 'b', 't']

/**
 * Two decimals with German separators and a `k`/`m`/`b`/`t` abbreviation (`999,00`, `1,25k`,
 * `2,50m`), as `numeral(value).format('0,0.00a')` with the app's `de` numeral locale.
 */
export const formatCompactTwoDecimals = (value: number): string => {
  let scaled = value
  let index = 0
  while (index < compactAbbreviations.length - 1 && Math.abs(Number(scaled.toFixed(2))) >= 1000) {
    scaled /= 1000
    index += 1
  }
  return `${formatTwoDecimals(scaled)}${compactAbbreviations[index]}`
}
